import { render } from "./ServiceTypesSettings.vue?vue&type=template&id=583d5d6c&scoped=true"
import script from "./ServiceTypesSettings.vue?vue&type=script&lang=js"
export * from "./ServiceTypesSettings.vue?vue&type=script&lang=js"

import "./ServiceTypesSettings.vue?vue&type=style&index=0&id=583d5d6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583d5d6c"]])

export default __exports__